import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';

export default function OAuthSuccess() {
  const [searchParams] = useSearchParams();

  const synced = searchParams.get('synced') === 'true';
  const created = parseInt(searchParams.get('created') || '0', 10);
  const skipped = parseInt(searchParams.get('skipped') || '0', 10);
  const errors = parseInt(searchParams.get('errors') || '0', 10);
  const syncError = searchParams.get('syncError');

  return (
    <div className="max-w-2xl mx-auto p-6 mt-12">
      <div className="bg-green-50 border border-green-200 rounded-lg p-8 text-center">
        <div className="text-6xl mb-4">✅</div>
        <h1 className="text-2xl font-bold text-green-900 mb-2">
          Authentication Successful
        </h1>
        <p className="text-green-700">
          Your Jobber account is now connected. The system will automatically create safety forms for new jobs.
        </p>
      </div>

      {/* Sync results */}
      {synced && (
        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-blue-900 mb-3">
            Initial Job Sync Complete
          </h2>
          <div className="space-y-2 text-sm text-blue-800">
            <p>
              <span className="font-medium">{created}</span> JSA form links created
            </p>
            {skipped > 0 && (
              <p>
                <span className="font-medium">{skipped}</span> jobs skipped (already had links)
              </p>
            )}
            {errors > 0 && (
              <p className="text-yellow-700">
                <span className="font-medium">{errors}</span> jobs had errors
              </p>
            )}
          </div>
        </div>
      )}

      {/* Sync error */}
      {syncError && (
        <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-yellow-900 mb-2">
            Sync Warning
          </h2>
          <p className="text-sm text-yellow-800">
            Your account was connected, but the initial job sync encountered an issue: {syncError}
          </p>
          <p className="text-sm text-yellow-700 mt-2">
            You can manually sync jobs from the dashboard.
          </p>
        </div>
      )}

      <div className="mt-6 text-center">
        <Link
          to="/dashboard"
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
